import produce from "immer"
import {
  CONTENT_TABLE_CLEAR_SELECTION,
  CONTENT_TABLE_SELECT_MAP,
  CONTENT_TABLE_SELECT_REGION,
  CONTENT_TABLE_SELECT_SUBREGION
} from "./content-table.actions"
import type { ContentTableAction, IContentTableState } from "./content-table.types"

export const contentTableInitialState: IContentTableState = {}

export function contentTableReducer(
  currentState: IContentTableState | undefined,
  action: ContentTableAction
): IContentTableState {
  const state = currentState ?? contentTableInitialState
  switch (action.type) {
    case CONTENT_TABLE_SELECT_REGION: {
      return selectRegion(state, action.payload as string)
    }
    case CONTENT_TABLE_SELECT_SUBREGION: {
      return selectSubRegion(state, action.payload as string)
    }
    case CONTENT_TABLE_SELECT_MAP: {
      return selectMap(state, action.payload as string)
    }
    case CONTENT_TABLE_CLEAR_SELECTION: {
      return clearSelection(state)
    }
    default: {
      return state
    }
  }
}

function selectRegion(currentState: IContentTableState, regionId: string): IContentTableState {
  return produce(currentState, (draftState: IContentTableState) => {
    draftState.selectedRegionId = regionId
    draftState.selectedSubRegionId = undefined
    draftState.selectedMapId = undefined
  })
}

function selectSubRegion(currentState: IContentTableState, subRegionId: string): IContentTableState {
  return produce(currentState, (draftState: IContentTableState) => {
    draftState.selectedSubRegionId = subRegionId
    draftState.selectedMapId = undefined
  })
}

function selectMap(currentState: IContentTableState, mapId: string): IContentTableState {
  return produce(currentState, (draftState: IContentTableState) => {
    draftState.selectedMapId = mapId
  })
}

function clearSelection(currentState: IContentTableState): IContentTableState {
  return produce(currentState, (draftState: IContentTableState) => {
    draftState.selectedRegionId = undefined
    draftState.selectedSubRegionId = undefined
    draftState.selectedMapId = undefined
  })
}
